import { FC, ReactNode } from "react";

interface SimplePageHeaderProps {
    title: string;
    rightSlot?: ReactNode;
}

const SimplePageHeader: FC<SimplePageHeaderProps> = ({ title, rightSlot }) => {
    return (
        <div className="w-full max-w-[1280px] mx-auto flex items-center justify-between mt-[40px] mb-[50px]">
            <h1 className="font-geologica text-2xl md:text-4xl font-medium uppercase text-primary-400">
                {title}
            </h1>
            {rightSlot && (
                <div className="flex items-center gap-6">
                    {rightSlot}
                </div>
            )}
        </div>
    );
};

export default SimplePageHeader;